module.exports = __webpack_public_path__ + "de8cb869a04a21dad5630936831678f7.jpg";